import React from 'react';
// SVG
import Guide from '../assets/appbar/logos/Guides.svg';
import Blog from '../assets/appbar/logos/Blog.svg';
import BusinessSeries from '../assets/appbar/logos/BusinessSeries.svg';
import Flight from '../assets/appbar/logos/Flight.svg';
import Car from '../assets/appbar/logos/Car.svg';
import Hotel from '../assets/appbar/logos/Hotel.svg';
import ExpenseManagement from '../assets/appbar/logos/ExpenseManagement.svg';
import KCare from '../assets/appbar/logos/Kcare.svg';
import { useNavigate } from 'react-router-dom';


const ProductDropdown = ({ visibility }) => {
    const navigate = useNavigate();
    const linkToProducts = (path) => navigate(path);
    return (
        <section className={`navbar_product_dropdown ${visibility && 'dd_show'}`}>
            <aside onClick={() => linkToProducts("/travel")}>
                <div className='menu_icon'>
                    <img src={Flight} alt='navbar_product_icon' />
                </div>
                <div>
                    <h5>Flight</h5>
                    <h6>Global travel software</h6>
                </div>
            </aside>
            <aside onClick={() => linkToProducts("/k-care")}>
                <div className='menu_icon'>
                    <img src={KCare} alt='navbar_product_icon' />
                </div>
                <div>
                    <h5>K Care</h5>
                    <h6>Travel alerts and notfications</h6>
                </div>
            </aside>
            <aside onClick={() => linkToProducts("/hotel")}>
                <div className='menu_icon'>
                    <img src={Hotel} alt='navbar_product_icon' />
                </div>
                <div>
                    <h5>Accommodation</h5>
                    <h6>Business hotel and accommodation</h6>
                </div>
            </aside>
            <aside onClick={() => linkToProducts("/expense-management")}>
                <div className='menu_icon'>
                    <img src={ExpenseManagement} alt='navbar_product_icon' />
                </div>
                <div>
                    <h5>Expense Management</h5>
                    <h6>Invoice, reporting and tracking</h6>
                </div>
            </aside>
            <aside onClick={() => linkToProducts("/car")}>
                <div className='menu_icon'>
                    <img src={Car} alt='navbar_product_icon' />
                </div>
                <div>
                    <h5>Car</h5>
                    <h6>Corporate car solution</h6>
                </div>
            </aside>
        </section>
    );
};

const ResourcesDropdown = ({ visibility }) => {
    const navigate = useNavigate();
    const linkToResource = (path) => navigate(path);
    return (
        <section className={`navbar_resources_dropdown ${visibility && 'dd_show_resource'}`}>
            <aside onClick={() => linkToResource("/guides")}>
                <img src={Guide} alt="resources_dd" />
                <div>
                    <h5>Guides</h5>
                    <h6>Travel jargon simplified</h6>
                </div>
            </aside>
            <aside onClick={() => window.open("https://gokardinal.medium.com/", "_blank")}>
                <img src={Blog} alt="resources_dd" />
                <div>
                    <h5>Blog</h5>
                    <h6>Resources for travel management</h6>
                </div>
            </aside>
            <aside onClick={() => linkToResource("/business-series")}>
                <img src={BusinessSeries} alt="resources_dd" />
                <div>
                    <h5>Business Series</h5>
                    <h6>Live series for today’s businesses </h6>
                </div>
            </aside>
        </section>
    );
};

export { ProductDropdown, ResourcesDropdown };